'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../tslib.es6-130a177d.js');
var styled = require('styled-components');
var CloseIcon = require('../CloseIcon-cf59af30.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var CloseButton = styled__default['default'](CloseIcon.CloseIcon).attrs({ as: 'button', 'aria-label': 'close' }).withConfig({ displayName: "ww-uikit_CloseButton_loy4z5oi", componentId: "sc-18fp5qn" })(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    background: unset;\n    border: unset;\n    color: ", ";\n    box-shadow: 0 0 0 0 transparent;\n    transition: 0.3s ease-out box-shadow;\n    &:focus {\n        box-shadow: 0 0 0 1px currentColor;\n    }\n"], ["\n    background: unset;\n    border: unset;\n    color: ", ";\n    box-shadow: 0 0 0 0 transparent;\n    transition: 0.3s ease-out box-shadow;\n    &:focus {\n        box-shadow: 0 0 0 1px currentColor;\n    }\n"])), function (_a) {
    var $color = _a.$color, theme = _a.theme;
    return ($color ? theme.colors[$color] : 'inherit');
});
var templateObject_1;

exports.default = CloseButton;
//# sourceMappingURL=index.js.map
